var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSandWatch = function SvgSandWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M7.5 7 5.008 4.923c-.37-.309-.556-.463-.689-.652a1.8 1.8 0 0 1-.259-.553C4 3.495 4 3.254 4 2.772V1.167M7.5 7l2.493-2.077c.37-.309.555-.463.688-.652.118-.168.206-.355.26-.553.06-.223.06-.464.06-.946V1.167M7.5 7 5.007 9.077c-.37.309-.556.463-.689.652a1.8 1.8 0 0 0-.259.553c-.06.223-.06.464-.06.946v1.605M7.5 7l2.493 2.077c.37.309.555.463.688.652.118.168.206.355.26.553.06.223.06.464.06.946v1.605M2.833 1.167h9.333M2.834 12.833h9.333"
  })));
};
export default SvgSandWatch;